import { useState } from 'react';
import { Dialog, Box, Typography, selectClasses } from '@mui/material';
import styled from 'styled-components';
import { colors } from '../../../../theme';

//Icons
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

//Global Components
import GlobalButton from '../../../../components/global/button';
import GlobalDropdown from '../../../../components/global/dropdown';
import FilterOption from '../../../../components/global/filterOption';

import { useAppSelector } from '../../../../hooks/hooks';

interface BorderBoxProps {
    selected: boolean;
}

const CreatePlan = (props) => {
    const { open, setOpen, onGenerate } = props;

    const termPlannerState = useAppSelector((state) => state.termPlanner);

    const [selected, setSelected] = useState({
        term: null,
        weekday: null,
        type: '',
    });

    const courseTimeArr = [
        {
            label: 'Daytime',
            value: 'day',
        },
        {
            label: 'Night-time',
            value: 'night',
        },
    ];

    const handleSelect = (key, value) => {
        let newValue = value;

        setSelected({
            ...selected,
            [key]: newValue,
        });
    };

    const handleTermChange = (event) => {
        const term = event.target.value;
        setSelected({ ...selected, term });
    };

    const handleGenerateNewPlan = () => {
        onGenerate(selected.term, selected.weekday, selected.type);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog open={open} maxWidth="xs" fullWidth onClose={handleClose}>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', padding: '35px 40px' }}>
                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', mb: '25px' }}>
                    <AddButton />
                    <Typography variant="h4" sx={{ fontWeight: 700, color: colors.blue.main }}>
                        Course Listing For Term
                    </Typography>
                    <XButton onClick={handleClose} />
                </Box>
                <Box sx={{ display: 'flex' }}>
                    <Label>Term</Label>
                    <GlobalDropdown value={selected.term} data={termPlannerState.terms} placeholder="Select a term" name="termCode" field="termCampusId" width="300px" onChange={handleTermChange} />
                </Box>
                <Box sx={{ m: '10px 0' }}>
                    <FilterOption
                        label="Day"
                        data={termPlannerState.weekdays}
                        state={selected?.weekday?.id}
                        name={'shortName'}
                        selectedID={'id'}
                        onOptionClick={(value: any) => {
                            handleSelect('weekday', value);
                        }}
                    />
                </Box>
                <Box sx={{ mb: '20px' }}>
                    <FilterOption
                        label="Type"
                        data={courseTimeArr}
                        state={selected.type}
                        name={'label'}
                        onClickValue={'value'}
                        onOptionClick={(value: any) => {
                            handleSelect('type', value);
                        }}
                    />
                </Box>
                <GlobalButton variant="contained" text="Generate" onClick={handleGenerateNewPlan} />
            </Box>
        </Dialog>
    );
};

export default CreatePlan;

const AddButton = styled(AddIcon)`
    background: ${colors.blue.main};
    border-radius: 100%;
    color: white;
    cursor: pointer;
    width: 30px !important;
    height: 30px !important;
`;

const XButton = styled(CloseIcon)`
    background: #f8f8f8;
    color: ${colors.blue.main};
    border-radius: 5px;
    cursor: pointer;
`;

const Label = styled.div`
    display: inline-block;
    margin-right: 5px;
    padding: 5px 0;
    background-color: ${colors.blue.light};
    color: ${colors.blue.main};
    border-radius: 5px;
    font-size: 10px;
    font-weight: 700;
    width: 55px;
    text-align: center;
`;

const BorderBox = styled.div<BorderBoxProps>`
    display: inline-block;
    padding: 3px 7px;
    border-radius: 5px;
    font-size: 12px;
    margin-right: 5px;
    cursor: pointer;

    ${(props) =>
        props.selected
            ? `
                background: ${colors.blue.main};
                color: white; 
                border: 1px solid ${colors.blue.main}
    `
            : ` 
             background: white; border: 1px solid ${colors.grey.medium};
    `}
`;
